import { FC } from 'react'

import { styled } from 'styled-components'

import Icon from 'core/components/Icon'
import Clickable from 'core/components/lib/Clickable'

import { useResourceBack } from './useResourceNavigate'

type ResourceBackButtonProps = {
  /** Where to land when there is no in-app history to step back through. */
  fallbackPath: string
}

const ResourceBackButton: FC<ResourceBackButtonProps> = ({ fallbackPath }) => {
  const back = useResourceBack()

  return (
    <BackLink
      ariaLabel='Back'
      onClick={() => back(fallbackPath)}
      size='sm'
      variant='link'
    >
      <Icon name='arrow_back' />
      Back
    </BackLink>
  )
}

export default ResourceBackButton

/**
 * The link variant underlines on hover, but text-decoration on a flex row is
 * drawn per item, so the icon and the label underline at their own baselines
 * and the line steps. A square-cornered border under the whole row is one
 * unbroken line; the variant's 6px radius would curl its ends.
 */
const BackLink = styled(Clickable)`
  gap: 4px;
  align-items: center;
  border-bottom: 1px solid transparent;
  border-radius: 0;

  &&:hover {
    border-bottom-color: currentcolor;
    text-decoration: none;
  }
`
